import { Card, Theme, SxProps, Box } from '@mui/material';
import { SidebarComponents } from '../sidebarComponents/SidebarComponents';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { CanvasScreen } from 'src/components/SCADA/canvasScreen';
import { ConfigurationDrawer } from '../configurationDrawer/ConfigurationDrawer';
import { EditorMode } from '../../types';
import { ReactFlowProvider } from '@xyflow/react';

type Props = {
  sx?: SxProps<Theme>;
  mode: EditorMode;
};

export const MainDashboard = ({ sx, mode }: Props) => (
  <Card sx={{ ...sx }}>
    <DndProvider backend={HTML5Backend}>
      <Box sx={{ display: 'flex', position: 'relative' }}>
        <SidebarComponents mode={mode} />
        <ReactFlowProvider>
          <CanvasScreen mode={mode} />
        </ReactFlowProvider>
        <ConfigurationDrawer mode={mode} />
      </Box>
    </DndProvider>
  </Card>
);
